"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _IndexModule = _interopRequireDefault(require("../../../Index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RestoreForm = function RestoreForm(_ref) {
  var code = _ref.code,
      codeValidate = _ref.codeValidate,
      confirmPassword = _ref.confirmPassword,
      confirmPasswordValidate = _ref.confirmPasswordValidate,
      disabledButton = _ref.disabledButton,
      setDisabledButton = _ref.setDisabledButton,
      handleConfirmResetPassword = _ref.handleConfirmResetPassword,
      isTempBlocked = _ref.isTempBlocked,
      loading = _ref.loading,
      newPassword = _ref.newPassword,
      newPasswordValidate = _ref.newPasswordValidate,
      setCode = _ref.setCode,
      setCodeValidate = _ref.setCodeValidate,
      setConfirmPassword = _ref.setConfirmPassword,
      setConfirmPasswordValidate = _ref.setConfirmPasswordValidate,
      setNewPassword = _ref.setNewPassword,
      setNewPasswordValidate = _ref.setNewPasswordValidate,
      userName = _ref.userName;
  return /*#__PURE__*/_react["default"].createElement(_antd.Form, {
    className: _IndexModule["default"].loginForm
  }, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    value: userName,
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.UserOutlined, {
      className: "site-form-item-icon"
    }),
    disabled: true
  })), isTempBlocked === false && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "code",
    hasFeedback: true,
    validateStatus: codeValidate,
    rules: [{
      required: true,
      message: "Porfavor ingrese el código"
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.NumberOutlined, {
      className: "site-form-item-icon"
    }),
    placeholder: "C\xF3digo",
    className: _IndexModule["default"].customeInput,
    value: code,
    onChange: function onChange(e) {
      return setCode(e.target.value.trim());
    },
    onKeyUp: function onKeyUp(e) {
      return e.target.value.trim().length < 6 ? setCodeValidate("error") : setCodeValidate("success");
    }
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "newPassword",
    hasFeedback: true,
    validateStatus: newPasswordValidate,
    dependencies: ["code"],
    rules: [{
      required: true,
      message: "Porfavor ingrese su contraseña, mínimo 10 caracteres",
      min: 10
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.LockOutlined, {
      className: "site-form-item-icon"
    }),
    placeholder: "Nueva Contrase\xF1a",
    className: _IndexModule["default"].customeInput,
    value: newPassword,
    onChange: function onChange(e) {
      return setNewPassword(e.target.value.trim());
    },
    type: "password",
    onKeyUp: function onKeyUp(e) {
      return e.target.value.trim().length < 10 ? setNewPasswordValidate("error") : setNewPasswordValidate("success");
    }
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, {
    name: "confirmPassword",
    dependencies: ["newPassword"],
    hasFeedback: true,
    validateStatus: confirmPasswordValidate,
    rules: [{
      required: true,
      message: "Las contraseñas deben coincidir",
      min: 10
    }]
  }, /*#__PURE__*/_react["default"].createElement(_antd.Input, {
    prefix: /*#__PURE__*/_react["default"].createElement(_icons.LockOutlined, {
      className: "site-form-item-icon"
    }),
    placeholder: "Confirme Contrase\xF1a",
    className: _IndexModule["default"].customeInput,
    value: confirmPassword,
    onChange: function onChange(e) {
      return setConfirmPassword(e.target.value.trim());
    },
    type: "password",
    onKeyUp: function onKeyUp(e) {
      return e.target.value.trim() === newPassword ? setConfirmPasswordValidate("success") : setConfirmPasswordValidate("error");
    }
  })), /*#__PURE__*/_react["default"].createElement(_antd.Form.Item, null, /*#__PURE__*/_react["default"].createElement(_antd.Button, {
    disabled: disabledButton,
    type: "ghost",
    htmlType: "submit",
    loading: loading,
    block: true,
    className: _IndexModule["default"].loginButton,
    onClick: handleConfirmResetPassword
  }, "Enviar"))));
};

var _default = RestoreForm;
exports["default"] = _default;